import React from "react";
import { ConfigProvider, App } from "antd";
import enUS from "antd/locale/en_US";
import deDE from "antd/locale/de_DE";
import { useTranslation } from "react-i18next";

interface AntdConfigProviderProps {
  children: React.ReactNode;
}

export const COLOR_PRIMARY = "#1677FF";
export const COLOR_PRIMARY_HOVER = "rgb(7,64,141)";

export default function AntdConfigProvider({
  children,
}: AntdConfigProviderProps): React.ReactNode {
  const { i18n } = useTranslation();

  const getAntdLocale = () => {
    if (i18n.language === "de") {
      return deDE;
    }

    return enUS;
  };

  return (
    <ConfigProvider
      locale={getAntdLocale()}
      theme={{
        token: {
          fontFamily: "Roboto, Arial, sans-serif",
          colorPrimary: COLOR_PRIMARY,
          colorLink: COLOR_PRIMARY,
          colorLinkHover: COLOR_PRIMARY_HOVER,
          colorLinkActive: COLOR_PRIMARY,
        },
        // https://ant.design/docs/react/migrate-less-variables#how-to-use-component-token
        components: {
          Layout: {
            headerHeight: "var(--header-height)",
          },
        },
      }}
    >
      <App message={{ duration: 5 }}>{children}</App>
    </ConfigProvider>
  );
}
